export const isDev = (): boolean => {
	return import.meta.env.VITE_RUN_ENV === 'development';
};

export const isCI = (): boolean => {
	return import.meta.env.VITE_RUN_ENV === 'ci';
};
